<template>
  <div>
    <div class="top_img_content" v-if="initInfo.type == 3">
      <img class="top_img1" src="../../assets/img/highTest.jpg" />
    </div>
    <div class="top_img_content" v-if="initInfo.type == 4">
      <img class="top_img1" src="../../assets/img/cailiaojiagong.jpg" />
    </div>
    <div class="top_img_content" v-if="initInfo.type == 5">
      <img class="top_img1" src="../../assets/img/shijihaocai.jpg" />
    </div>
    <div class="materialTop" :class="{ borderTop: initInfo.type == 2 }" v-if="initInfo.testTypeList.length">
      <div class="materialHeader" id="materialTop">
        <div v-for="(item, index) in initInfo.testTypeList" @click="selectName(item, index)" 
          class="materialBox"
          :key="item.index">
          <div class="materialName" :class="{ isActive: activeIndex == index }">{{ item.dictLabel }}</div>
        </div>
      </div>
    </div>
    <div class="materialList" ref="materialList" id="materialList">
      <el-empty v-if="equipList.length == 0" description="暂无数据"></el-empty>
      <el-row :gutter="50" type="flex" style="flex-wrap: wrap;" v-else>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="(i, index) in equipList" :key="i + index + 'a'">
          <equipment-card
            :equipment="i"
            :image-prefix="imgurl"
            :purchase="initInfo.type == 5"
            @details="detailsHandle"
            @action="toAppoint"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { equipList } from "@/api/request";
import equipmentCard from "@/components/equipmentCard.vue";
export default {
  components: {
    equipmentCard
  },
  props: {
    initInfo: {
      type: [Object, Array],
      default: () => []
    }
  },
  data() {
    return {
      typeHideList: [],
      imgurl: process.env.VUE_APP_FILE_API,
      activeIndex: 0,
      observer: null,
      equipList: [],
      pageSize: 20,
      pageNum: 1,
      dataTotal: 0,
      loading: false,
      equipmentClassification: undefined
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true
      equipList({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        isCloudScene: this.initInfo.type,
        isGrounding: 1,
        status: 1,
        equipmentClassification: this.equipmentClassification
      }).then(res => {
        this.dataTotal = res.total;
        if (res.rows.length > 0) {
          this.equipList = this.equipList.concat(res.rows.map(i => {
            return {
              ...i,
              imgUrl: i.fileList.length > 0 ? i.fileList[0].url : ""
            };
          }));
          if (this.equipList.length == res.total) {
            this.loading = true
          } else { 
            this.loading = false
          }
        }
      });
    },
    handleScroll() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;
      if (scrollTop + clientHeight >= scrollHeight - 345) {
        this.loadMore();
      }
    },
    loadMore() {
      if (this.dataTotal > this.equipList.length && !this.loading) {
        this.pageNum++;
        this.getList();
      }
    },
    selectName(item, index) {
      this.equipList = [];
      this.pageNum = 1;
      this.activeIndex = index;
      if (index != 0) {
        this.equipmentClassification = item.dictLabel;
      } else {
        this.equipmentClassification = undefined;
      }
      this.getList();
    },
    detailsHandle(i) {
      this.$router.push({
        path: "/equipDetails",
        query: {
          id: i.id,
          type: this.$route.query.type ? this.$route.query.type : 0
        }
      });
    },
    // 未登录时进入登录页，成功后继续打开当前设备的预约页面
    toAppoint(i) {
      const appointRoute = this.$router.resolve({
        path: "/appointPage",
        query: {
          id: i.id,
          type: this.$route.query.type ? this.$route.query.type : 0,
        },
      }).route.fullPath;
      if(this.$store.getters.token) {
        this.$router.push(appointRoute);
        return;
      }
      this.$router.push({
        path: "/login",
        query: {
          redirect: appointRoute,
        },
      });
    }
  }
};
</script>
<style scoped>
.borderTop {
  border-top: 1px solid #e8e8e8
}

.materialHeader {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  height: 80px;
  background: #fff;
  width: 80%;
  margin: 0 auto;
}

.materialTop {
  width: 100%;
  background: #fff;
}

.isActive {
  border: 1px solid #4d6fff!important;
  border-radius: 26px;
  color: #4d6fff;
}

.materialBox {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}

.materialName {
  cursor: pointer;
  width: 80%;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 18px;
  padding: 0 5px;
  border: 1px solid #fff;
}

.materialList {
  width: 80%;
  margin: 0 auto;
}

@media only screen and (max-width: 1440px) {
  .materialName {
    font-size: 16px;
    height: 40px;
    line-height: 40px;
  }
}

@media only screen and (max-width: 1200px) {
  .materialName {
    font-size: 13px;
    height: 30px;
    line-height: 30px;
  }
}</style>